/* Templ3 — product options, add to cart. No dependencies.
   window.T3 (money format + routes) is set in layout/templ3.liquid. */
(function () {
  'use strict';

  var T3 = (window.T3 = window.T3 || {});
  T3.routes = T3.routes || { cart: '/cart', cartAdd: '/cart/add.js' };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function money(cents) {
    var format = T3.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key.indexOf('no_decimals') !== -1) value = String(Math.round(cents / 100));
      if (key.indexOf('comma') !== -1) value = value.replace('.', ',');
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, key.indexOf('comma') !== -1 ? '.' : ',');
    });
  }

  var toast = $('[data-t3-toast]');
  var toastTimer;
  function showToast(text, linkHref, linkText) {
    if (!toast) return;
    toast.textContent = text;
    if (linkHref) {
      var a = document.createElement('a');
      a.href = linkHref; a.textContent = linkText;
      toast.appendChild(document.createTextNode(' '));
      toast.appendChild(a);
    }
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }

  $$('[data-t3-product]').forEach(function (root) {
    var form = $('[data-t3-form]', root) || $('form', root);
    var idInput = $('[data-t3-variant-id]', root);
    var addBtn = $('[data-t3-add]', root);
    var priceEl = $('[data-t3-price]', root);
    var variants = [];
    try { variants = JSON.parse($('[data-t3-variants]', root).textContent); } catch (e) { variants = []; }

    function chosen() {
      return $$('[data-t3-option]', root).map(function (group) {
        var input = $('input:checked', group);
        return input ? input.value : null;
      });
    }
    function update() {
      var values = chosen();
      var variant = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      })[0];
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-label-unavailable');
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = addBtn.getAttribute(variant.available ? 'data-label-add' : 'data-label-soldout');
      if (priceEl) {
        priceEl.innerHTML = money(variant.price) +
          (variant.compare_at_price > variant.price ? ' <s>' + money(variant.compare_at_price) + '</s>' : '');
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-t3-option] input', root).forEach(function (input) { input.addEventListener('change', update); });

    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addBtn.disabled = true;
        fetch(T3.routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (res) {
            addBtn.disabled = false;
            if (!res.ok) { showToast(res.data.description || 'Could not add that to your cart.'); return; }
            showToast('Added to cart.', T3.routes.cart, 'View cart');
            return fetch(T3.routes.cart + '.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                $$('[data-t3-cart-count]').forEach(function (el) { el.textContent = String(cart.item_count); });
              });
          })
          .catch(function () { form.submit(); });
      });
    }
  });
})();
